<!--
  @Description: 
  @Author: wang.y 
  @Date: 2025-07-23 
-->
<template>
  <div class="header" id="home-header">
    <div class="header-content">
      <div class="header-left">
        <div class="header-logo" @click="handleChangeRoute('index')">
          <img :src="static_img_url+'pic/logo.png?v=' + $store.state.imgVersion" />
        </div>
        <!-- <div class="header-str">
          <p class="p1">{{'中国·苏州' | dealLanguage('SUZHOU·CHINA')}}</p>
          <p class="p2">{{activityDetail.startTime | time_moment('YYYY.M.D')}}-{{activityDetail.endTime | time_moment('YYYY.M.D')}}</p>
        </div> -->
      </div>
      <div class="header-navigation">
        <div :class="['nav-item']" v-for="item,index in navPosition1" :key="index" @click="handleChangeRoute('contentPage' + item.id)">
          <span>{{item.pageName | dealLanguage(item.enPageTitle)}}</span>
        </div>
        <Dropdown @on-visible-change="handleChangeVisible($event, '大会会议')" @on-click="handleChangeRoute">
          <div :class="['nav-item', visible['大会会议'] && 'visible']">
            <span>{{'大会会议' | dealLanguage('Program')}}</span>
            <i class="iconfont">&#xe669;</i>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="guests">{{'发言嘉宾' | dealLanguage('Previous Guests')}}</DropdownItem>
            <DropdownItem name="theme">{{'大会日程' | dealLanguage('Conference Agenda')}}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <!-- <div :class="['nav-item']" v-for="item,index in navPosition2" :key="index" @click="handleChangeRoute('contentPage' + item.id)">
          <span>{{item.pageName | dealLanguage(item.enPageTitle)}}</span>
        </div> -->
        <div :class="['nav-item']" @click="handleChangeRoute('compReg')">
          <span>{{'展览赞助' | dealLanguage('Sponsor & Exhibit')}}</span>
        </div>
        <div :class="['nav-item']" @click="handleChangeRoute('signUp')">
          <span>{{'注册参会' | dealLanguage('Registration')}}</span>
        </div>
        <div :class="['nav-item']" @click="handleChangeRoute('newsList')">
          <span>{{'新闻动态' | dealLanguage('News')}}</span>
        </div>
        <div :class="['nav-item']" @click="handleChangeRoute('newsList2')" v-if="language == 'en'">
          <span>China CGT 100 Pioneers</span>
        </div>
        <!-- <div :class="['nav-item']" v-if="!user_key" @click="handleChangeRoute('login')">
          <span>{{'登录' | dealLanguage('LOG IN')}}</span>
        </div>
        <Dropdown @on-visible-change="handleChangeVisible($event, '用户中心')" @on-click="handleChangeRoute" v-else>
          <div :class="['nav-item', visible['用户中心'] && 'visible']">
            <span>{{'用户中心' | dealLanguage('USER CENTER')}}</span>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="userInfo">{{'个人信息' | dealLanguage('Personal center')}}</DropdownItem>
            <DropdownItem name="myTickets">{{'我的门票' | dealLanguage('My Tickets')}}</DropdownItem>
            <DropdownItem name="orderList">{{'订单和发票' | dealLanguage('Orders and Invoices')}}</DropdownItem>
            <DropdownItem name="companions">{{'同行人' | dealLanguage('Companion')}}</DropdownItem>
            <DropdownItem name="quit"><span style="color: #FF0000">{{'退出登录' | dealLanguage('Log out')}}</span></DropdownItem>
          </DropdownMenu>
        </Dropdown> -->

        <div :class="['lang-item']" @click="handleChangeLanguage" v-if="$route.name != 'newsDetail'">
          <span :class="[language == 'zh' && 'active']">中</span>
          <span>/</span>
          <span :class="[language == 'en' && 'active']">EN</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Aexitlogin } from '@/service/app'
import filter from 'js/filter'
export default {
  inject: ['globalInsertRecords', 'login', 'reload'],
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      filter,
      visible: {
       '大会会议': false,
       '用户中心': false,
      },
    }
  },
  computed: {
    ...mapState({
      static_img_url: (state) => state.static_img_url,
      user_key: (state) => state.user_key,
      contentNav: (state) => state.contentNav,
      activityDetail: (state) => state.activityDetail,
      language: (state) => state.language,
    }),
    /**
     * 关于CSGCT
     */
    navPosition1() {
      let arr = this.contentNav.filter((item) => [263].includes(item.id))
      return arr
    },
    /**
     * 展览赞助107 参会注册108
     */
    navPosition2() {
      let arr = this.contentNav.filter((item) => [264].includes(item.id))
      return arr
    },
  },
  methods: {
    handleChangeVisible(value, name) {
      this.visible[name] = value
      if (value) {
        this.globalInsertRecords({
          contentId: 0,
          contentType: 81,
          viewType: 2,
          keyword: name,
        })
      }
    },
    /**
     * 处理路由变化
     *
     * @param name 路由名称
     */
    handleChangeRoute(name, query) {
      // 判断name是否包含contentPage
      if (name.indexOf('contentPage') > -1) {
        let content_id = name.split('contentPage')[1] - 0
        let index = this.contentNav.findIndex((item) => item.id == content_id)
        if (index > -1) {
          this.globalInsertRecords({
            contentId: content_id,
            contentType: 81,
            viewType: 1,
            keyword: this.contentNav[index].pageName,
          })
        }
        this.$router.push({ name: 'exhibitionDesc', params: { id: content_id } })
        return
      }
      let kw = ''
      switch (name) {
        case 'index':
          kw = 'logo'
          break
        case 'guests':
          kw = '发言嘉宾'
          break
        case 'signUp':
          kw = '注册参会'
          break
        case 'exhibitors':
          kw = '展商名录'
          break
        case 'toplist':
          kw = '榜单'
          break
        case 'qa':
          kw = '常见问题'
          break
        case 'newsList':
          kw = '新闻动态'
          break
        case 'newsList2':
          kw = 'China CGT 100 Pioneers'
          break
        case 'exhibitors':
          kw = '合作伙伴'
          break
        case 'login':
          kw = '登录'
          break
        case 'userInfo':
          kw = '个人信息'
          break
        case 'myTickets':
          kw = '我的门票'
          break
        case 'orderList':
          kw = '订单和发票'
          break
        case 'companions':
          kw = '同行人'
          break
        case 'quit':
          kw = '退出登录'
          break
        case 'compReg':
          kw = '展览赞助'
          break
        case 'agenda':
          kw = '大会议程'
          break
        case 'theme':
          kw = '大会日程'
          break
      }
      this.globalInsertRecords({
        contentId: 0,
        contentType: 81,
        viewType: 1,
        keyword: kw,
      })
      switch (name) {
        case 'quit':
          this.exitlogin()
          break
        case 'toplist':
          window.open('https://vb100.vbdata.cn/Index/list', '_blank')
          break
        case 'login':
          this.login()
          break
        case 'newsList2':
          this.$router.push({ name: 'newsList', query: { type: 2 } })
          break
        default:
          this.$router.push({ name })
      }
    },
    async exitlogin() {
      let res = await Aexitlogin()
      if (res.code == 0) {
        this.$store.commit('updateUserKey', '')
        this.$store.commit('updateUser', '')
        this.$store.commit('setUUserId', '')
        this.$Message.success( this.language == 'zh' ? '退出登录成功！' : 'Log out successfully!')
        this.$router.push({ name: 'index' })
        this.reload()
      } else {
        this.$Message.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleChangeLanguage() {
      let newLanguage = this.language === 'zh' ? 'en' : 'zh'
      // this.$store.commit('setLanguage', newLanguage)
      // localStorage.setItem('vbefLanguage', newLanguage)

      let routerQuery = this.$route.query
      if (newLanguage == 'en') {
        delete routerQuery.language
        } else {
        routerQuery.language = newLanguage
      }
    
      const { href } = this.$router.resolve({ path: this.$route.path, query: routerQuery })
      location.href = href
      
      // this.$router.resolve({ path: this.$route.path, query: routerQuery })
      // this.$nextTick(() => {
      //   this.reload()
      // })
    },
  },
}
</script>
<style lang='stylus' scoped>
.header-content
  width 1200px
  height 64px
  margin 0 auto
  display flex
  align-items center
  justify-content space-between
  .header-left
    display flex
    align-items center
  .header-logo
    font-size 0
    display flex
    align-items center
    img
      width auto
      height 60px
      cursor pointer
  .header-str
    margin-left 6px
    height 36px
    .p1
      font-size 16px
      color #C8161D
      line-height 18px
    .p2
      color #C8161D
      font-size 12px
      line-height 1
      margin-top 5px
  .header-navigation
    display flex
    align-items center
    justify-content space-between
    font-size 14px
    > div
      &+div
        margin-left 40px
    .lang-item
      width 41px
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      position relative
      transition all 0.3s
      span
        transition all 0.2s
        font-size 14px
        &.active
          font-size 16px
          color #C8161D
      &:hover
        color #C8161D
    .nav-item
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      transition all 0.3s
      font-size 16px
      position relative
      span
        &+i
          transition all 0.3s
          margin-left 4px
        &.active
          color #C8161D
      &:hover, &.active
        color #C8161D
      &.visible
        color #C8161D
        i
          transform rotate(180deg)
  >>> .ivu-dropdown
    .ivu-select-dropdown
      padding 20px 0 5px
      margin 0
      border-radius 0
      box-shadow none
      background none
      .ivu-dropdown-menu
        box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
        background-color #fff
        padding 5px 0
        .ivu-dropdown-item
          color #333333
</style>